<template>
	<div class="c-file" :class="{'flex-start-end': media, 's-media': media}">
		<div v-if="media" class="c-file-media flex-wrap">
			<div v-if="!fileList.length" class="c-file-media-item flex-center empty" @click="uploadHandle">
				<i class="tf" :class="`tf-${media}`"></i>
			</div>
			<div v-for="(item, i) in fileList" :key="i" class="c-file-media-item flex-center">
				<video v-if="media == 'video'" :src="item"></video>
				<img v-else :src="item">
				<a class="flex-center" @click="remove(i)" @mousedown.stop><i class="tf tf-cross"></i></a>
			</div>
		</div>
		
		<div class="flex-column">
			<div class="c-file-button flex-center-cross">
				<c-button color="gray" :icon="icon" hollow @click="uploadHandle">{{button}}</c-button>
			</div>
			<div v-if="$slots.word || word || fileTypeText" class="c-file-word flex-column">
				<slot name="word"></slot>
				<span v-if="!$slots.word && word">{{word}}</span>
				<span v-if="fileTypeText">支持格式：{{fileTypeText.join('，')}}</span>
			</div>
		</div>
		
		<ul v-if="!media" v-show="fileList.length">
			<li v-for="(item, i) in fileList" :key="i"><span>{{fileName(item)}}</span><a @click="remove(i)">[删除]</a></li>
		</ul>
	</div>
</template>

<script>
	export default {
		props: {
			type: String,
			
			size: [String, Number],
			
			media: String,
			
			icon: {
				type: String,
				default: 'upload'
			},
			
			button: {
				type: String,
				default: '上传文件'
			},
			
			word: String,
			
			value: [String, Array],
			
			limit: {
				type: Number,
				default: 1
			},
			
			custom: Boolean
		},

		data() {
			return {
				fileList: []
			}
		},

		computed: {
			fileType() {
				if (this.type) {
					let arr = [];
					this.type.split(',').forEach(item => {
						arr = arr.concat({
							image: ['jpg', 'jpeg', 'png'],
							video: ['mp4'],
							word: ['doc', 'docx'],
							excel: ['xls', 'xlsx'],
							zip: ['zip', '7z', 'rar']
						}[item] || [item])
					});
					return arr;
				}
				return '';
			},
			
			fileTypeText() {
				if (this.type) {
					let arr = [];
					this.type.split(',').forEach(item => {
						arr = arr.concat({
							image: ['图片'],
							video: ['mp4'],
							word: ['doc(x)'],
							excel: ['xls(x)'],
							zip: ['压缩包']
						}[item] || [item])
					});
					return arr;
				}
				return '';
			},
			
			fileName() {
				return path => {
					path = path.split('/');
					return path[path.length - 1];
				}
			},
			
			spare() {
				return this.fileList.length < this.limit;
			}
		},

		watch: {
			value() {
				this.update();
			},
			
			fileList(val) {
				this.$emit('input', this.limit == 1 ? (val[0] || '') : val);
			}
		},
		
		mounted() {
			this.update();
		},

		methods: {
			update() {
				this.fileList = this.value ? (typeof this.value == 'object' ? this.value : this.value.toString().split(',')) : [];
			},
			
			remove(i) {
				this.fileList.splice(i, 1);
			},

			uploadHandle() {
				if (this.custom) {
					this.$emit('click');
				} else {
					this.uploadFile({
						fileType: Array.from(this.fileType, item => '.' + item).join(','),
						fileSize: this.size,
						multiple: parseInt(this.limit) > 1,
						success: data => {
							if (this.limit == 1) {
								this.fileList = data;
							} else {
								this.fileList = this.fileList.concat(data);	
							}
							this.$emit('afterUpload');
						}
					});
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-file {
		>>> .c-button {
			border-radius: 0 !important;
		}
		
		&:not(.s-media) {
			.c-file-button {
				margin-right: .2rem;
			}
		}
		
		&.s-media {
			height: 1.6rem;
			
			.c-file-word {
				margin: .12rem 0 .04rem;
			}
		}
		
		&-media {
			&-item {
				position: relative;
				box-sizing: border-box;
				width: 1.6rem;
				height: 1.6rem;
				border: 1px solid #DDDDDD;
				margin-right: .3rem;
				background: #fff;
				box-sizing: border-box;
				
				&.empty {
					font-size: 30px;
					color: #aaa;
					cursor: pointer;
				}
				
				video {
					width: 100%;
					height: 100%;
					background: #000;
				}
				
				a {
					position: absolute;
					right: 0;
					top: 0;
					width: .36rem;
					height: .36rem;
					font-size: .24rem;
					color: #fff;
					background: rgba(0,0,0,.6);
				}
			}
		}
		
		&-word {
			margin-top: .2rem;
			line-height: .36rem;
			font-size: .26rem;
			color: #999;
			
			elder({
				line-height: .46rem,
				font-size: .36rem
			})
		}
		
		ul {
			margin-top: .1rem;
			
			li {
				padding: .05rem 0;
				line-height: .4rem;
				font-size: .26rem;
				word-break: break-all;
				color: #0030FF;
				
				a {
					margin-left: .2rem;
					color: #f00;
				}
			}
		}
	}
</style>
